import React from 'react';
import { faThumbsDown } from '@fortawesome/pro-solid-svg-icons/faThumbsDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ThumbsDownSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faThumbsDown} {...props} />;
}
